import { Injectable, isDevMode } from '@angular/core';
import { EMPTY, Subject } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { tap } from 'rxjs/internal/operators/tap';
import { SatisfactionConfigDaoService } from 'src/app/dao/satisfaction-dao-services/satisfaction-config-dao-service/satisfaction-config-dao.service';
import { UserService } from '../../user-service/user.service';
import { UserStorageService } from '../../user-storage-service/user-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SatisfactionConfigService {

  accessToken = 'SAT';
  private refreshSatisfactionConfigListener = new Subject<any>();

  constructor(private satisfactionConfigDaoService: SatisfactionConfigDaoService,
              private userService: UserService,
              private userStorageService: UserStorageService) { }

  public getSatisfactionConfig() {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.satisfactionConfigDaoService.getSatisfactionConfig(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o['data']['config'])
      );
    }
    return EMPTY;
  }

  public updateSatisfactionConfigSatisfaction(active) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.satisfactionConfigDaoService.updateSatisfactionConfigSatisfaction(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), active).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public updateSatisfactionConfigComments(activeComments) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.satisfactionConfigDaoService.updateSatisfactionConfigComments(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), activeComments).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public updateSatisfactionConfigType(type) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.satisfactionConfigDaoService.updateSatisfactionConfigType(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), type).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public refreshSatisfactionsConfig() {
    this.refreshSatisfactionConfigListener.next();
  }

  public listenRefreshSatisfactionConfig() {
    return this.refreshSatisfactionConfigListener.asObservable();
  }

  public getSatisfactionsConfig() {
    this.refreshSatisfactionConfigListener.next();
  }

  public listenGetSatisfactionConfig() {
    return this.refreshSatisfactionConfigListener.asObservable();
  }
}
